import React, {useEffect, useMemo, useState} from 'react';
import SideBar from "../../../common/SideBar";
import NavBar from "../../../common/NavBar";
import {Link} from "react-router-dom";
import PaymentsService from "../../../services/PaymentsService";
import CssBaseline from "@material-ui/core/CssBaseline";
import EnhancedTable from "./paymentsTableComponent/EnhancedTable";
import Spinner from "reactjs-simple-spinner";


const Payments = (props) => {

    const columns = useMemo(
        () => [
            {
                Header: 'Receipt Date',
                accessor: 'created_at',
            },
            {
                Header: 'Policy No',
                accessor: 'policy_number',
            },
            {
                Header: 'Amount',
                accessor: 'amount',
            },
            {
                Header: 'Payment Channel',
                accessor: 'payment_channel',
            },
            {
                Header: 'Reference',
                accessor: 'reference_number',
            },
            {
                Header: 'Action',
                accessor: 'id',
                Cell: ({value}) => (
                    <span>
                <a href={"https://nhaka-api.alpham.co.zw/api/download/invoice/" + value} target="_blank"
                   className="btn btn-sm btn-primary">Download Receipt&nbsp; <i
                    className="fa fa-cloud-download"/>
                </a>
                            </span>
                )
            }

        ],
        []
    )


    const [data, setData] = useState([])
    const [skipPageReset, setSkipPageReset] = useState(false)

    // We need to keep the table from resetting the pageIndex when we
    // Update data. So we can keep track of that flag with a ref.

    // When our cell renderer calls updateMyData, we'll use
    // the rowIndex, columnId and new value to update the
    // original data
    const updateMyData = (rowIndex, columnId, value) => {
        // We also turn on the flag to not reset the page
        // setSkipPageReset(true)
        // setData(old =>
        //     old.map((row, index) => {
        //         if (index === rowIndex) {
        //             return {
        //                 ...old[rowIndex],
        //                 [columnId]: value,
        //             }
        //         }
        //         return row
        //     })
        // )
    }

    const [loading, setLoading] = useState(false);


    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        setLoading(true)

        let token = JSON.parse(localStorage.getItem('token'));
        console.log("leads token", token)
        PaymentsService.getAllPayments(token).then(response => {
            console.log(response.data.allPayments);
            setData(response.data.allPayments);
            setLoading(false)
        }).catch(err => {
            console.log(err);
            setData([])
            setLoading(false)
        });


    }, []);


    return (
        <div>
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            <div id="main-content" className="main-panel ps-container ps-theme-default">
              <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>
                <div className="content">
                    <div className="container-fluid">
                        <ul className="breadcrumb">
                            <Link to="/dashboard"><a href><i className="fa fa-home"/>&nbsp;Dashboard</a> </Link>
                            &nbsp;|&nbsp;
                            Receipts
                        </ul>
                        <div className="row mt">
                            <div className="card col-lg-12">
                                <div className="content-panel bg-white">
                                    {loading && (
                                        <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                            <Spinner
                                                size="medium"
                                                message="Please wait....."
                                                line-fg-color="#64c3c2"
                                            />
                                        </div>

                                    )}
                                    {!loading && (
                                        <div id="table">
                                            {/*Receipts table*/}
                                            <CssBaseline/>
                                            <EnhancedTable
                                                columns={columns}
                                                data={data}
                                                setData={setData}
                                                updateMyData={updateMyData}
                                                skipPageReset={skipPageReset}
                                            />
                                        </div>
                                    )}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Payments;
